var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSRaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5593_2401)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.2666 3.7334V14.9307H78.1746V3.7334H80.2666Z",
    fill: "#49D7F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2264 12.0496L69.3753 14.9336H67.2L70.8491 3.73633H73.367L76.9999 14.9336H74.713L73.8592 12.0552H70.2264V12.0496ZM73.4299 10.4036L72.0975 5.87598H72.005L70.6726 10.4036H73.4299Z",
    fill: "#49D7F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.5V60.375V74.1333C0 79.5825 4.41747 84 9.86668 84H71.8846C75.0978 84 78.1794 82.8938 80.4515 80.9246C82.7236 78.9555 84 76.2848 84 73.5V18.6667H77.9423H66.7556C64.9392 18.6667 63.4667 17.1942 63.4667 15.3778V0H12.1154C8.90218 0 5.82059 1.10625 3.54852 3.07538C1.27644 5.04451 0 7.71523 0 10.5Z",
    fill: "#49D7F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.996 29.724C32.0133 29.724 33.668 29.9847 34.96 30.506C36.2747 31.0047 37.2493 31.764 37.884 32.784C38.5187 33.804 38.836 35.0847 38.836 36.626C38.836 37.918 38.598 38.9947 38.122 39.856C37.646 40.7173 37.034 41.4087 36.286 41.93C35.5607 42.4287 34.79 42.8253 33.974 43.12L40.638 54H37.068L31.186 43.97H26.358V54H23.298V29.724H29.996ZM29.826 32.376H26.358V41.386H29.996C31.3107 41.386 32.3873 41.216 33.226 40.876C34.0647 40.5133 34.6767 39.992 35.062 39.312C35.47 38.632 35.674 37.782 35.674 36.762C35.674 35.6967 35.4587 34.8467 35.028 34.212C34.62 33.5773 33.9853 33.1127 33.124 32.818C32.2627 32.5233 31.1633 32.376 29.826 32.376ZM59.6804 54L56.7564 46.486H47.1344L44.2444 54H41.1504L50.6364 29.622H53.3904L62.8424 54H59.6804ZM53.1184 36.422C53.0504 36.2407 52.9371 35.912 52.7784 35.436C52.6197 34.96 52.4611 34.4727 52.3024 33.974C52.1664 33.4527 52.0531 33.056 51.9624 32.784C51.8491 33.2373 51.7244 33.702 51.5884 34.178C51.4751 34.6313 51.3504 35.0507 51.2144 35.436C51.1011 35.8213 50.9991 36.15 50.9084 36.422L48.1544 43.766H55.8384L53.1184 36.422Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5593_2401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSRaLogo);
export default __webpack_public_path__ + "static/media/S_RA_Logo.8b6a30f679fa9b25daf458fac82f5a07.svg";
export { ForwardRef as ReactComponent };